import { tv } from "../../../util/tv";

export const heroHighlightVariant = tv({
  slots: {
    base: ["relative z-30", "sm:max-w-sm md:max-w-full sm:mx-auto"],
    figure: [],
    bgImage: [],
    icon: [
      "absolute inset-0 m-auto",
      "translate-x-[17%] translate-y-[17%]",
      "p-[5%]",
      "w-1/2 h-1/2",
      "text-white",
      "[&>path]:stroke-1",
    ],
  },
  variants: {
    show: {
      false: {
        base: ["hidden"],
      },
      true: {
        base: [],
      },
    },
    appearance: {
      default: {
        base: ["w-full"],
        figure: ["w-[60%]", "mx-auto"],
        bgImage: ["w-full"],
        icon: ["p-[3%]", "translate-x-[13%] translate-y-[18%]"],
      },
      compact: {
        base: ["sm:max-w-[250px] md:max-w-[250px]"],
      },
      elegant: {},
    },
  },
  defaultVariants: {
    show: false,
    appearance: "default",
  },
});
